<template lang="pug">
  hotsite-dcom
    .conteudo
      bloco#dcom_orientacoes.-nomargin.-softpadding.-fullheight
        //- HEADER
        header(slot="header")
          titulo.-withbar.-upper Orientações e Manuais
        //- CONTENT
        .texto(slot="content")
          p Aqui você encontra as orientações e manuais para download
          hotsite-lista(v-if="!naoTemOrientacoes"
            :itens="orientacoes"
            :icone="'arquivo'")
          mensagem.-warn(v-else)
            p Nenhuma orientação ou manual foi encontrada no momento
          paginacao(
            v-if="totalPages > 1",
            :gender='"a"',
            :object='"orientações e manuais"',
            :total='totalEditais',
            :totalPage='totalPages',
            :perPage='perPage',
            :perPageAtual='orientacoes.length',
            :pageAtual="page")
        //- FOOTER
        footer(slot="footer")
          back-and-share
</template>

<style lang="scss">
  #dcom_orientacoes {
    .lista {
      > .item {
        @extend %font_medium;
        font-size: 18px;

        &:before {
          font-family: 'FontAwesome';
          font-size: 1.4rem;
          margin-right: 15px;
        }

        &.pasta:before { content: '\f07b' }
        &.arquivo:before { content: '\f15b' }
      }
    }
  }

  #hotsite {
    .corpo {
      .conteudo {
        #dcom_orientacoes {
          ul.pagination {
            li:before {
              display: none !important;
            }
          }
        }
      }
    }
  }
</style>

<script>
import BackAndShare from 'COMPONENTS/BackAndShare'
import Bloco from 'COMPONENTS/Bloco'
import HotsiteDcom from 'PAGES/dcom/Base'
import HotsiteLista from 'COMPONENTS/HotsiteLista'
import Mensagem from 'COMPONENTS/Mensagem'
import Paginacao from 'COMPONENTS/Paginacao'
import Titulo from 'COMPONENTS/ElementTitle'

import OrientacoesManuaisService from '../../../js/api/dcom/OrientacoesManuaisService'

export default {
  components: {
    BackAndShare,
    Bloco,
    HotsiteDcom,
    HotsiteLista,
    Mensagem,
    Paginacao,
    Titulo
  },

  data () {
    return {
      orientacoes: [],
      naoTemOrientacoes: false,
      totalPages: '',
      totalOrientacoes: '',
      perPage: 5,
      page: ''
    }
  },

  methods: {
    loadOrientacoes (perPage, page) {
      OrientacoesManuaisService.getOrientacoesManuais('dcom', 'orientacoes-e-manuais', perPage, page)
      .then(response => {
        this.orientacoes = response.data.map(orientacao => {
          return { titulo: orientacao.title.rendered, url: orientacao.acf.arquivo }
        })
        this.totalPages = parseInt(response.headers['x-wp-totalpages'])
        this.totalEditais = parseInt(response.headers['x-wp-total'])
        if (this.orientacoes.length === 0) {
          this.naoTemOrientacoes = true
        }
      })
      return this.orientacoes
    }
  },

  watch: {
    page: function () {
      this.orientacoess = this.loadOrientacoes(this.perPage, this.page)
    }
  },

  mounted () {
    this.page = this.$route.params.page ? parseInt(this.$route.params.page) : 1
    this.orientacoess = this.loadOrientacoes(this.perPage, this.page)
  },

  beforeUpdate () {
    this.page = this.$route.params.page ? parseInt(this.$route.params.page) : 1
  }
}
</script>




// WEBPACK FOOTER //
// Orientacoes.vue?be39a578